export const IDV2_CONTAINER_ID = 'idv2-container';
export const LEGACY_IDV_CONTAINER_ID = 'layout-container';
export const NAVIGATION_HEADER_PORTAL_ID = 'navigation-header-portal';
export const IDV_BODY_CONTENT_CONTAINER_ID = 'idv-body-content-container';
